import React, { useState } from 'react';
import { IconPfp } from './SidebarIcons.jsx';

const EMPTY_PFP_INNER_RATIO = 0.65;

export function Pfp({ url, size }) {
  const [failedUrl, setFailedUrl] = useState(null);
  const showImage = url && url !== failedUrl;

  return (
    <span className="vs-pfp" style={{ width: size, height: size }}>
      {showImage ? (
        <img src={url} alt="" onError={() => setFailedUrl(url)} />
      ) : (
        <IconPfp width={size * EMPTY_PFP_INNER_RATIO} />
      )}
    </span>
  );
}
